// @flow
import * as React from 'react';
import DropdownOption from 'app/common/react/ui/experimental/DropdownOption';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import { Box, Divider, Touchable } from 'gestalt';

type Props = {|
  bold?: boolean,
  external?: boolean,
  hasDividerAfter?: boolean,
  icon?: 'add' | 'cancel' | 'globe' | 'pinterest' | 'question-mark' | 'report' | 'send',
  onClick?: () => void,
  text: string,
  url?: string,
  description?: string,
|};

const ListItem = ({
  bold,
  description,
  external,
  hasDividerAfter,
  icon,
  onClick,
  text,
  url,
}: Props) => {
  const content = (
    <Box role="listitem" overflow="hidden">
      <DropdownOption bold={bold} description={description} icon={icon} text={text} />
    </Box>
  );
  return (
    <Box>
      {url ? (
        <NavigateLink to={url} external={external} onClick={onClick}>
          {content}
        </NavigateLink>
      ) : (
        <Touchable onTouch={onClick} fullWidth={false}>
          {content}
        </Touchable>
      )}
      {hasDividerAfter && <Divider />}
    </Box>
  );
};

export default ListItem;
